import { RootState } from "../../app/store";
import { useAppSelector } from "../../app/hooks";

export const useEmployeeId = (): number => {
    return useAppSelector((state: RootState) => state.root.employeeId);
};
